import { Card, Text } from "@/components/ui"

/** A coupon code in a small dashed slip, monospace and selectable, centred on a fixed 24px box and truncating when space runs out. */
export function CouponCodeChip({ code }: { code: string }) {
  return (
    <Card variant="stub" tone="game" padding="none" className="inline-flex h-6 min-w-0 max-w-full items-center">
      <span className="flex h-full min-w-0 items-center px-2">
        <Text as="span" size="xs" weight="bold" tracking="wide" leading="none" tone="default" truncate className="block select-all font-mono [text-box:trim-both_cap_alphabetic] supports-[not(text-box:trim-both_cap_alphabetic)]:translate-y-px">
          {code}
        </Text>
      </span>
    </Card>
  )
}
